import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Avatar from 'react-avatar';
import Griddle, { plugins } from 'griddle-react';
import { connect } from 'react-redux';

const filterStyle = {
  classNames: {
    Filter: 'pull-right form-control',
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

const CustomRowComponent = connect((state, props) => ({
  agent: plugins.LocalPlugin.selectors.rowDataSelector(state, props)
}))(({ agent }) => (
  <div className="col-lg-4 col-md-6 col-sm-12 agent-card-wrapper">
  	<div data-item={agent.id} onClick={agent.showAgentDetails} className="agent-card">
  		<Avatar name={agent.image} src={agent.image} className="agent-image" round />
	    <ul>
	    	<li><h3>{agent.first_name} {agent.last_name}</h3></li>
		    <li><p>{agent.email}</p></li>
		    <li><p>{agent.mobile}</p></li>
	    </ul>
	   </div>
  </div>
));

const CustomTableComponent = OriginalComponent => class CustomTableComponent extends Component {
  static contextTypes = {
    components: PropTypes.object
  }

  render() {
    return <this.context.components.TableBody />
  }
}

const CustomTableBody = ({ rowIds, Row, style, className }) => (
  <div className="row">
    { rowIds && rowIds.map(r => <Row key={r} griddleKey={r} />) }
  </div>
);

class AgentCard extends React.Component {
  constructor(props) {
    super(props);
  }
	render(){
	  return (
	  	<div>
		  	<Griddle
			    data={this.props.agents}
			    pageProperties={{
			      pageSize: 6
			    }}
			    plugins={[plugins.LocalPlugin]}
			    styleConfig={filterStyle}
			    components={{
			      Row: CustomRowComponent,
			      TableContainer: CustomTableComponent,
			      TableBody: CustomTableBody,
			      SettingsToggle: (props) => null
			    }}
			  />
		</div>
		);
	}
}

export default AgentCard;


// WEBPACK FOOTER //
// src/routes/agency/components/AgentCard.js